module.exports = __webpack_public_path__ + "static/media/pad-thai.f2c9ca1f.jpg";